import React,{ useState , useEffect } from 'react';
import { Box } from '@mui/material';
import { Base64 } from 'js-base64';

import CodeEditor from './CodeEditor';
import { codeSubmission, getCodeLanguages } from 'services';
import { useServices, useSnackbar } from 'contexts';
import useCodingStore from './CodingStore';
import { QuestionStates, SectionWiseData } from './constant';
import ConfirmationDialog from 'dialogs/ConfirmationDialog';

const CodingSection = () => {
  const service = useServices();
  const snackbar = useSnackbar();

  const [
    attempt, questionType, timeLeft, updateAnalysis,
    questionState, setQuestionState,
  ] = useCodingStore(state => [
    state.attempt, state.questionType, state.timeLeft, state.updateAnalysis,
    state.questionState, state.setQuestionState
  ]);

  const [languages, setLanguages] = useState([]);
  const [openSubmitdialog, setOpenSubmitdialog] = useState(false);
  const [timeUp, setTimeUp] = useState(false);
  const [code, setCode] = useState("");
  const [language, setLanguage] = useState();
  const [codeInput , setCodeInput] = useState('');

  useEffect(() => {
    const fetchCodeLanguages = async () => {
      try {
        const result = await service.callService(getCodeLanguages);
        const updatedResult = result.map(({ id, ...rest }) => ({
          _id: id.toString(),
          ...rest,
        }));
  
        setLanguages(updatedResult);
        setLanguage(updatedResult[0]);

      } catch (err) {
        console.error(err.message);
      } 
    };

    fetchCodeLanguages();
  }, []);
  
  const handleCodeSubmittion= async() => {
    setQuestionState(QuestionStates.CODE_EVALUATING);

    const encodedCode = Base64.encode(code);
    const encodedInput = Base64.encode(codeInput);
    
    try {
      await service.callService(codeSubmission, {
        codeChallengeAttemptId: attempt?._id,
        languageId: language?._id,
        sourceCode: encodedCode,
        stdin: encodedInput,
        base64Encoded: true,
        questionType,
        duration: SectionWiseData[questionType].codingTime - timeLeft,
        autosubmitted: timeUp,
        submittedAt: new Date()
      });

      updateAnalysis({
        languageId: language?._id
      });

      setQuestionState(QuestionStates.CODE_SUBMITTED);
      setOpenSubmitdialog(false);
      setTimeUp(false);
    } catch (error) {
      console.log(error);
      setOpenSubmitdialog(false);
      snackbar.error("Uh Oh! Unable to submit code");
      setQuestionState(QuestionStates.CODING);
    }
  }

  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    if(questionState !== QuestionStates.CODING) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (timeLeft <= 0) {
      setOpenSubmitdialog(true);
      setTimeUp(true);
    }
  
  }, [timeLeft]);

  React.useEffect(()=>{
    let timeout;
    if (openSubmitdialog && timeUp) {
      timeout = setTimeout(() => {
        handleCodeSubmittion();
      }, 3000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [openSubmitdialog, timeUp])

  return (
    <Box>
      <CodeEditor
        languageOptions={languages}
        disableEditing={questionState !== QuestionStates.CODING}
        onSubmit={()=> setOpenSubmitdialog(true)}
        code={code}
        setCode={(c)=> {
          setCode(c)
          const encodedCode = Base64.encode(code);
          updateAnalysis({sourceCode: encodedCode});
        }}
        language={language}
        setLanguage={setLanguage}
        setCodeInput={setCodeInput}
        codeInput={codeInput}
      />
      
      <ConfirmationDialog
        open={openSubmitdialog}
        title={
          timeUp
          ? <span style={{ color: "#E2483C"}}>Time's Up!</span>
          : "Final code submission!"
        }
        message={
          timeUp ? "You are out of time and your code has been submitted automatically." :
            "Once you submit the final code, no further changes can be made!"
          }
        onClose={() => {}}
        hideCloseIcon={true}
        primaryAction={'Submit'}
        secondaryAction={timeUp ? "Okay" : 'Go back'}
        onPrimaryAction={handleCodeSubmittion}
        onSecondaryAction={() =>{
          if(timeUp){
            handleCodeSubmittion();
          }else{
            setOpenSubmitdialog(false)
          }
        }
        } 
        disablePrimaryAction={timeUp ? true : false}
      />
    </Box>
  )
};

export default CodingSection;